export default __webpack_public_path__ + "static/media/benefit_2.c16aba7f.png";